import {h} from 'preact';
import {useState} from "preact/hooks";
import MenuCopilotSpellCheck from "./MenuCopilotSpellCheck";
import MenuCopilotOverview from "./MenuCopilotOverview";
import MenuCopilotPrintCheck from "./MenuCopilotPrintCheck";
import MenuCopilotDesignTips from "./MenuCopilotDesignTips";
import LikeIcon from "./icon/LikeIcon";
import DisLikeIcon from "./icon/DisLikeIcon";
import aiService from "../service/aiService";
import constants from "../constants";
import {useEffect} from "preact/compat";

export enum CopilotView {
  Overview, SpellCheck, PrintCheck, DesignTips
}

interface Word {
  current: string;
  correct: string;
}

interface MenuCopilotProps {
  isPaidMember: boolean;
  active: boolean;
  toggled: boolean;
  onClose: () => void;
  setActiveMember: () => void;
  isPrintable: boolean;
  designId: string;
}

export default function MenuCopilot({
                                      toggled,
                                      active,
                                      onClose,
                                      isPaidMember,
                                      setActiveMember,
                                      isPrintable,
                                      designId
                                    }: MenuCopilotProps) {
  const [view, setView] = useState<CopilotView>(CopilotView.Overview);
  const [askForFeedback, setAskForFeedback] = useState(true);

  //@ts-ignore
  const [currentCount, setCurrentCount] = useState(window.data.member.aiCurrentCount);
  //@ts-ignore
  const [countLimit, setCountLimit] = useState(window.data.member.aiCountLimit);
  const [limitExceeded, setLimitExceeded] = useState(false);

  function onMemberActivated() {
    setCurrentCount(0);
    setCountLimit(50);
    setActiveMember()
  }

  useEffect(() => {
    setAskForFeedback(true);
  }, [view])

  useEffect(() => {
    setLimitExceeded(countLimit - currentCount <= 0);
  }, [currentCount, countLimit]);

  function sendFeedback(value: string) {
    //@ts-ignore
    const {id, email} = window.data.member;

    let bot = "spell-check";
    if (view === CopilotView.PrintCheck) {
      bot = "print-check";
    } else if (view === CopilotView.DesignTips) {
      bot = "design-tips";
    }

    aiService.postFeedback({
      value,
      memberId: id,
      email: email,
      bot
    }).then(() => {
      setAskForFeedback(false);
    })
  }

  return <div className={`ai-helper ${toggled ? "vis" : ""}`} onClick={ev => ev.stopPropagation()}>
    <header>
      <button className={"close"} onClick={onClose}>
        <svg>
          <use href="#app-icon-delete-close"></use>
        </svg>
      </button>
      <h2>
        <svg>
          <use xlinkHref={constants.appPrefix + "/svg/icons.svg#magic-stars"}/>
        </svg>
        Menu Copilot<span className="tm">TM</span>
      </h2>

      <h5 className={"disc"}>Experimental AI features - You may encounter unexpected results. Feedback welcome.</h5>

      {isPaidMember && <h6 className={`meter ${countLimit === currentCount ? "red" : ""}`}>
        {!limitExceeded && <>
          <strong>{countLimit - currentCount} credits remaining of {countLimit}</strong>
          <i>(renews monthly)</i>
        </>}
        {limitExceeded && <>
          <strong>0 credits remaining</strong><i>(renews monthly)</i>
          <br />
          <span style={{fontWeight: "400"}}>If more credits needed, please drop us a note in chat.</span>
        </>}
      </h6>}

    </header>

    <MenuCopilotOverview visible={view === CopilotView.Overview} setView={setView} isPaidMember={isPaidMember}
                         setActiveMember={onMemberActivated} isPrintable={isPrintable} limitExceeded={limitExceeded}/>

    <MenuCopilotSpellCheck setView={setView} setCurrentCount={setCurrentCount} setCountLimit={setCountLimit}
                           visible={active && view === CopilotView.SpellCheck} isPaidMember={isPaidMember}
                           designId={designId}/>

    <MenuCopilotPrintCheck setView={setView} setCurrentCount={setCurrentCount} setCountLimit={setCountLimit}
                           visible={active && view === CopilotView.PrintCheck} isPaidMember={isPaidMember}
                           designId={designId}/>

    <MenuCopilotDesignTips setView={setView} setCurrentCount={setCurrentCount} setCountLimit={setCountLimit}
                           visible={active && view === CopilotView.DesignTips} isPaidMember={isPaidMember}
                           designId={designId}/>

    {(view === CopilotView.SpellCheck || view === CopilotView.PrintCheck || view === CopilotView.DesignTips) && askForFeedback &&
      <footer class={"helpful"}>
        <h3>Was this helpful?</h3>
        <div>
          <button onClick={() => sendFeedback("yes")}><LikeIcon/></button>
          <button onClick={() => sendFeedback("no")}><DisLikeIcon/></button>
        </div>
      </footer>}
  </div>
}
